import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import DashImportacaoModel from "../../../components/classes/DashImportacao";

import { useTranslation } from "react-i18next";

export default function ChartAmount01(props: ChartAmount01Props) {
  const { t } = useTranslation();

  const [seriesMixedChart, setSeriesMixedChart] = useState<{ name: string, type: string, data: number[] }[]>([]);
  const [optionsMixedChart, setOptionsMixedChart] = useState<ApexCharts.ApexOptions>({});

  useEffect(() => {

    var groupedByDay = props.data?.reduce(function (r, a) {
      r[new Date(a.dataRemessa).toUTCString()] = r[new Date(a.dataRemessa).toUTCString()] || [];
      r[new Date(a.dataRemessa).toUTCString()].push(a);
      return r;
    }, Object.create(null)) ?? [];

    var solicitado: number[] = [];
    var recebido: number[] = [];

    var sortedDays = Object.keys(groupedByDay).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
    sortedDays.forEach(key => {
      solicitado.push(groupedByDay[key].reduce((y: number, z: DashImportacaoModel) => y + z.quantidadePedido, 0));
      recebido.push(groupedByDay[key].reduce((y: number, z: DashImportacaoModel) => y + z.quantidadeEmbarque, 0));
    });

    setOptionsMixedChart({
      ...optionsMixedChart,
      xaxis: {
        type: "datetime",
        categories: sortedDays.map(x => new Date(x).toLocaleDateString())
      },
    });

    setSeriesMixedChart([
      {
        name: t("common.requested"),
        type: "area",
        data: solicitado
      },
      {
        name: t("common.received"),
        type: "area",
        data: recebido
      }
    ]);

  }, []);

  return (
    <div id="chartAmount01" className="mixed-chart">
      <ReactApexChart
        options={optionsMixedChart}
        series={seriesMixedChart}
        type="line"
        width="96%"
        height={290}
      />
    </div>
  );
}

interface ChartAmount01Props {
  data?: DashImportacaoModel[]
}